import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import FloatingMetricsCards from './FloatingMetricsCards';

const SentimentSection = () => {
  return (
    <Box
      sx={{
        mt: {xs: -25, sm: 0, md: 0},
        py: { xs: 6, md: 6 },
        px: { xs: 2, md: 6 },
        borderRadius: 4,
        maxWidth: 1200,
        zIndex: 10,
        bgcolor:"#FFF",
          borderRadius:6,
          border:"1px solid #E0E0E0",
        // bgcolor: '#F8F0FF',
        position: 'relative',
        overflow: 'hidden',
        boxShadow:"0px 0px 20px 20px rgba(0, 0, 0, 0.1)"
      }}
    >
      <Container 
        maxWidth="lg"
        sx={{
          position: 'relative',
        }}
      >
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={5}>
            <Box sx={{ maxWidth: 480}}>
              <Typography
                variant="h2"
                component="h2"
                sx={{
                  fontSize: { xs: '30px', md: '50px' },
                  fontWeight: 600,
                  color: '#4728c4',
                  mb: 1,
                  lineHeight: 1.2,
                  letterSpacing:-1.8,
                }}
              >
                Check the vibes.
            
                
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: '16px', md: '18px' },
                  color: '#4D4D4D', 
                  lineHeight: 1.6,
                }}
              >
                Evaluate comment sentiment with <b>Siftsy Score</b> and sentiment breakdown.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={7}>
              <Box 
                sx={{ 
                  position: 'relative', 
                  zIndex: 1, 
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center',
                  mb: {xs: -10, sm: -16, md: -18},
                  '@keyframes float': {
                    '0%': {
                      transform: 'translateY(0px)'
                    },
                    '50%': {
                      transform: 'translateY(-10px)'
                    },
                    '100%': {
                      transform: 'translateY(0px)'
                    }
                  },
                  animation: 'float 4s ease-in-out infinite'
                }}
              >
                <img width="80%" src="/scoring.png" alt="Sentiment Section" />
              </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default SentimentSection; 